export default __webpack_public_path__ + "static/media/211660_email_icon.30df618f.svg";